import { Tooltip } from 'antd';
import * as React from 'react';
import { cn } from '../../../utils/ClassNamesUtils';
import { OSCAR_ICON_SIZE } from '../../constants/AIAgentConstants';

interface OscarIconButtonProps {
	icon: React.ReactNode;
	/** Accessible name; also used as the hover tooltip. */
	label: string;
	onClick?: () => void;
	/** Rendered glyph size in px. Figma: 20 for the action row, 16 for close. */
	size?: number;
	disabled?: boolean;
	className?: string;
}

/**
 * Bare icon affordance used in the Oscar panel header. The design has no
 * button chrome — just the glyph — so this keeps the hit area at the glyph box
 * and expresses state through color alone.
 */
export const OscarIconButton = ({
	icon,
	label,
	onClick,
	size = OSCAR_ICON_SIZE.action,
	disabled,
	className,
}: OscarIconButtonProps) => (
	<Tooltip title={label}>
		<button
			type="button"
			aria-label={label}
			disabled={disabled}
			onClick={onClick}
			style={{ width: size, height: size, fontSize: size }}
			className={cn(
				'flex shrink-0 cursor-pointer items-center justify-center border-none bg-transparent p-0 leading-none text-character-primary transition-colors',
				'hover:text-[#54298e]',
				disabled && 'cursor-not-allowed text-character-disabled hover:text-character-disabled',
				className
			)}
		>
			{icon}
		</button>
	</Tooltip>
);

export default OscarIconButton;
